import { createContext, useContext, useState } from 'react';
import ar from 'translations/ar';
import en from 'translations/en';

const LanguageContext = createContext();

const translations = {
  ar,
  en
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('ar'); 
  
  const t = (key) => {
    return translations[language][key] || key;
  };
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ar' ? 'en' : 'ar');
  };
  
  const changeLanguage = (lang) => {
    if (lang === 'ar' || lang === 'en') {
      setLanguage(lang);
    }
  };
  
  return (
    <LanguageContext.Provider value={{ 
      language, 
      t, 
      toggleLanguage, 
      changeLanguage 
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const context = useContext(LanguageContext);
  
  if (!context) {
    throw new Error('useTranslation must be used within LanguageProvider');
  }
  
  return context;
}
